<template>
  <div>
    <component :is="slice.slice_type" v-for="(slice, sliceIndex) in slices" :key="sliceIndex" :slice="slice" />
    <div :class="$style.perksContainer">
      <component :is="slice.slice_type" v-for="(slice, sliceIndex) in perks" :key="sliceIndex" :slice="slice" :is-logged-in="isLoggedIn" />
    </div>
  </div>
</template>

<script>
import { Hero } from '@@/shared-slices'

import { isLoggedIn } from '~/mixins/isLoggedIn'

import { Categories, CardsList } from './components'

export default {
  name: 'PerksPageModule',

  components: { hero: Hero, categories_list: Categories, cards_list: CardsList },

  mixins: [isLoggedIn],

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      lastname: null,
      firstname: null,
      slices: this.data.body1.filter((s) => s.slice_type !== 'cards_list'),
      perks: this.data.body1.filter((s) => s.slice_type === 'cards_list'),
    }
  },
}
</script>
<style lang="scss" module>
.perksContainer {
  padding: 0 24px 128px;

  @include below(small) {
    padding: 0 24px 80px;
  }
}
</style>
